import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgReferralIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <g
      fill="currentColor"
      stroke="currentColor"
      strokeWidth={0.07}
      clipPath="url(#a)"
    >
      <path d="m9.4377 10.8951-.035.0026a3.8 3.8 0 0 1-.2767.0106v-.035a3.492 3.492 0 0 1-2.4778-1.0212 3.49 3.49 0 0 1-1.0237-2.4767zm0 0-.0027-.035-.0562-.7452-.0027-.0352-.0351.0029a2.706 2.706 0 0 1-2.0618-.7085 2.707 2.707 0 0 1-.8709-1.9985v-.0003a2.707 2.707 0 0 1 2.7175-2.721l.0001-.035-.0002.035a2.735 2.735 0 0 1 2.4402 1.5273l.0154.0313.0313-.0153.6714-.327.0315-.0152-.0153-.0315A3.5254 3.5254 0 0 0 8.0466 4.005a3.526 3.526 0 0 0-1.4204.8708z" />
      <path d="M14.3782 14.8737a4.36 4.36 0 0 1-3.0902-1.2829 4.3589 4.3589 0 0 1 0-6.1839 4.36 4.36 0 0 1 3.092-1.2864 4.359 4.359 0 0 1 3.092 1.2864 4.359 4.359 0 0 1 0 6.184 4.36 4.36 0 0 1-1.4187.9504 4.36 4.36 0 0 1-1.6751.3324Zm0 0 .0001-.035v.035zm-4.4453-2.701.0339-.0087-.0087-.0338-.1863-.7277-.0087-.0338-.0338.0085a3.0438 3.0438 0 0 1-2.9434-.8477l-.0772-.0841-.0004-.0005-.2004-.2109-.019-.02-.0238.0137-.2565.1476-.0001.0001-.0903.0516h-.0036l-.0082.0047c-.7501.4352-1.3728 1.0332-1.8468 1.7583v.0001c-.467.7181-.785 1.563-.9263 2.4957l-.0002.0012-.007.0597-.004.0335.0333.0052.7383.116.0345.0054.0055-.0345.0105-.0668v-.0005a5.49 5.49 0 0 1 .8034-2.1726c.365-.5578.8351-1.0304 1.397-1.388a3.83 3.83 0 0 0 1.6612.9235 3.83 3.83 0 0 0 1.9271.0048Zm1.9391.8449h-.0001a3.547 3.547 0 0 1-1.0409-2.5134v-.0002a3.544 3.544 0 0 1 1.0355-2.5172 3.544 3.544 0 0 1 2.5152-1.0404h.0002a3.55 3.55 0 0 1 3.293 2.1925 3.551 3.551 0 0 1-.7796 3.8786l-.0002.0001a3.544 3.544 0 0 1-2.5116 1.0438 3.544 3.544 0 0 1-2.5115-1.0438Z" />
      <path d="m14.3781 15.7387.0001-.035a3.975 3.975 0 0 1-1.5561-.323 3.97 3.97 0 0 1-1.3047-.907l-.0002-.0001-.0982-.1052-.0002-.0002-.2003-.211-.019-.0199-.0239.0137-.2566.1476-.0002.0002-.1263.0736a7 7 0 0 0-1.4271 1.0598l-.0252.0243.0242.0252.5168.5379.024.0249.0252-.0237c.3434-.323.7188-.61 1.1204-.8567a4.743 4.743 0 0 0 3.3273 1.3619h.0001a4.78 4.78 0 0 0 3.3275-1.3624 5.8 5.8 0 0 1 2.2026 2.2995 6.665 6.665 0 0 1 .6827 3.1025h-9.4329v.8223H21.379l.0017-.0333.0175-.3586v-.0002c.0635-1.4248-.1621-2.7495-.7632-3.9057-.5552-1.0785-1.4249-2.0044-2.6677-2.7211l-.0002-.0001-.1227-.0701-.0003-.0002-.2528-.1475-.024-.014-.0191.0201-.1997.2103-.0003.0003-.0949.0949h-.0041l-.0104.011a3.92 3.92 0 0 1-1.3031.9109 3.92 3.92 0 0 1-1.5576.3191zm0 0a3.959 3.959 0 0 0 2.8862-1.241l-5.8708-.1054.0984.1054a4.006 4.006 0 0 0 2.8862 1.241Z" />
      <path d="m5.9687 16.4751-.0046-.0297h-.899l1.7232-1.6462 1.7232 1.6462h-.9953v.4107a5.87 5.87 0 0 0 .527 2.5883l.0002.0007a4.5 4.5 0 0 0 .3606.618 4.155 4.155 0 0 1-2.386-3.267l-.0001-.0011zm-2.2067.082-.0172.0163.0088.022.2602.6503.0088.022h1.2462a4.887 4.887 0 0 0 1.4074 2.5917l.0001.0001c.8817.8392 2.0311 1.3019 3.171 1.5207l.028.0054.0108-.0264.2813-.6785.0109-.0263-.0235-.016c-.625-.4259-1.081-.9346-1.3768-1.5471-.25-.5238-.3926-1.1259-.4306-1.8271h1.2103l.0087-.0221.2567-.6468.0087-.0219-.0171-.0163-2.742-2.619-.0002-.0002-.2601-.246-.0242-.0229-.024.023-.2567.246v.0001z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgReferralIcon;
